import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'app/services/LupinoApi/user.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.css',
    imports: [ReactiveFormsModule]
})
export class ResetPasswordComponent {
	resetForm: FormGroup;
	errorMessage = '';
	isSubmitting = false;

	constructor(
		private fb: FormBuilder,
		private userService: UserService,
		private router: Router,
	) {
		// get token from URL if needed
		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get('token');

		this.resetForm = this.fb.group(
			{
				token: [token, Validators.required], // Ajoutez le token si nécessaire
				password: ['', [Validators.required, Validators.minLength(6)]],
				confirmPassword: ['', Validators.required],
			},
			{ validator: this.passwordMatchValidator },
		);
	}

	passwordMatchValidator(form: AbstractControl): { [key: string]: boolean } | null {
		const password = form.get('password');
		const confirmPassword = form.get('confirmPassword');

		// Vérifie si les mots de passe ne correspondent pas
		if (password && confirmPassword && password.value !== confirmPassword.value) {
			return { passwordMismatch: true };
		}

		return null;
	}

	onSubmit(): void {
		if (this.isSubmitting) return;
		this.errorMessage = '';
		if (this.resetForm.invalid) {
			this.resetForm.markAllAsTouched();
			if (!this.resetForm.value.token) {
				this.errorMessage = 'Ce lien est invalide. Demandez un nouvel email de réinitialisation.';
			}
			return;
		}
		const { password, token } = this.resetForm.value;
		this.isSubmitting = true;
		this.userService.resetPassword(password, token)
			.pipe(finalize(() => this.isSubmitting = false))
			.subscribe({
				next: (data) => {
					if (data?.result === 'OK') {
						this.router.navigate(['/reset-password-success'], { replaceUrl: true });
					} else {
						this.errorMessage = 'La réinitialisation a échoué. Le lien est peut-être invalide ou expiré. Demandez un nouvel email.';
					}
				},
				error: () => {
					this.errorMessage = 'Impossible de modifier votre mot de passe. Réessayez dans quelques instants.';
				},
			});
	}
}